export const amountViewFormat = (amount) => {
    // console.log('amount >= 10000000', amount/10000000, amount);
    const formattedAmount = amount.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
    if(isNaN(amount)){
      return formattedAmount;
    }
  
      if(amount < 999 && amount > -999) {
          return formattedAmount;
      }
  
      if(amount > -100000 && amount < 100000) {
          return "₹"+ (amount/1000).toFixed(2) + "K";
      }
      if( amount > -10000000 && amount < 10000000) {
          return "₹"+ (amount/100000).toFixed(2) + "L";
      }
    if(amount >= 10000000){
      // console.log('amount in cr');
      return "₹" +(amount/10000000).toFixed(2) + "cr";
    }
    return formattedAmount;
  }